import React from "react";
import { CreateOrEditGitTrigger } from "./CreateOrEditGitTrigger";
interface ReleaseCreationGitTriggerPageProps {
    triggerId: string;
}
export function ReleaseCreationGitTriggerPage({ triggerId }: ReleaseCreationGitTriggerPageProps) {
    return <CreateOrEditGitTrigger triggerId={triggerId}/>;
}
